import { apiCall } from "../../api/apiBase";

export interface Firm {
    id?: string;
    name: string;
    content: unknown;
    createdAt?: string;
    updatedAt?: string;
}

export interface FirmNameUpdate {
    name: string;
}

export interface FirmContentUpdate {
    content: unknown;
}

export function getAllFirms(): Promise<Firm[]> {
    return apiCall<Firm[]>("/firms", "GET");
}

export function createFirm(firm: Firm): Promise<Firm> {
    return apiCall<Firm>("/firms", "POST", firm);
}

export function getFirm(firmId: string): Promise<Firm> {
    return apiCall<Firm>(`/firms/${firmId}`, "GET");
}

export function deleteFirm(firmId: string): Promise<void> {
    return apiCall(`/firms/${firmId}`, "DELETE");
}

export function updateFirmName(
    firmId: string,
    nameUpdate: FirmNameUpdate
): Promise<Firm> {
    return apiCall<Firm>(`/firms/${firmId}/name`, "PUT", nameUpdate);
}

export function updateFirmContent(
    firmId: string,
    contentUpdate: FirmContentUpdate
): Promise<Firm> {
    return apiCall<Firm>(`/firms/${firmId}/content`, "PUT", contentUpdate);
}
